import getRaceDetailsById from './getRaceDetailsById'
import getRaces from './getRaces'

function normaliseCombatantFatigue(fatigue) {
  if (typeof fatigue !== 'string') {
    return fatigue
  }

  return fatigue.trim().toLowerCase()
}

function resolveCombatantDamageMod(character) {
  if (character?.damage_mod !== undefined && character?.damage_mod !== null) {
    return character.damage_mod
  }

  if (character?.damage_mod_melee_cur !== undefined && character?.damage_mod_melee_cur !== null) {
    return character.damage_mod_melee_cur
  }

  return '0'
}

function resolveCharacteristicCurrentValue(character, characteristicName) {
  const currentKey = `${characteristicName}_cur`

  if (character?.[currentKey] !== undefined && character?.[currentKey] !== null) {
    return character[currentKey]
  }

  if (!Array.isArray(character?.characteristics)) {
    return undefined
  }

  const characteristic = character.characteristics.find(
    (entry) => entry?.name === characteristicName,
  )

  return characteristic?.cur
}

function resolveCombatantCR(character) {
  const baseCR = character?.cr_cur ?? character?.cr ?? undefined

  if (typeof baseCR !== 'number') {
    return baseCR
  }

  return baseCR
}
//--------------------------------
// convert character to combatant
//--------------------------------
export default function convertCharacterToCombatant(character) {
  console.log('----------------------------')
  console.log('convertCharacterToCombatant = ', character)

  if (!character || typeof character !== 'object') {
    return null
  }

  let raceName = character?.race ?? null
  //-----------
  // get races
  //-----------
  let races = getRaces()
  //--------------
  // convert race
  //--------------
  try {
    let race = getRaceDetailsById(character?.race, races)
    raceName = race?.name ?? raceName
  } catch {
    alert(window.bbUiErrorMsg('race not found for ' + character?.name))
  }

  const combatant = {
    arena: character?.arena ?? null,
    player: character?.player ?? null,
    race: raceName,
    character: character?.id ?? null,
    image: character?.image ?? null,
    name: character?.name ?? '',
    status: 'Active',
    fatigue: normaliseCombatantFatigue(character?.fatigue),
    category: character?.category ?? 'Party',
    type: character?.type ?? 'Character',
    role: 'Default',
    damage_mod: resolveCombatantDamageMod(character),
    str:
      character?.str_cur ?? character?.str ?? resolveCharacteristicCurrentValue(character, 'str'),
    con:
      character?.con_cur ?? character?.con ?? resolveCharacteristicCurrentValue(character, 'con'),
    dex:
      character?.dex_cur ?? character?.dex ?? resolveCharacteristicCurrentValue(character, 'dex'),
    siz:
      character?.siz_cur ?? character?.siz ?? resolveCharacteristicCurrentValue(character, 'siz'),
    sr: character?.sr_cur ?? character?.sr ?? undefined,
    ca: character?.ca_cur ?? character?.ca ?? undefined,
    cr: resolveCombatantCR(character),
    second_weapon: Boolean(character?.second_weapon),
    shield: Boolean(character?.shield),
    ranged: Boolean(character?.ranged),
    magic: Boolean(character?.magic),
    special_action: Boolean(character?.special_action),
    special_reaction: Boolean(character?.special_reaction),
  }

  return combatant
}
